// extracted by mini-css-extract-plugin
export default {"wrap":"PM-z","subtitle":"QM-z","contentWrap":"RM-z","imgWrap":"SM-z","heading":"TM-z","copy":"UM-z"};